<template>
  <div
    :id="name"
    :data-field="name"
    :class="[
      { 'form-item-wrap': true },
      { error: feedbackStatus },
      { bottom: marginBottom },
      { marginTop: marginTop },
      { noPadding: noPadding },
      { noPaddingTop: noPaddingTop },
      { borderRadiusTop: borderRadiusTop },
      { borderRadiusBottom: borderRadiusBottom },
      { small: small },
      direction,
    ]"
  >
    <div class="form-item-inner-wrap">
      <div v-if="label" class="form-item-label">
        <div class="label-text-wrap">
          <span v-if="asterisk" class="form-item-asterisk">*</span>
          <label class="form-item-label-text">{{ label }}</label>
          <span v-if="labelDesc" class="form-item-label-desc">{{ labelDesc }}</span>
        </div>
        <div v-if="icon" class="label-icon">
          <i :class="icon"></i>
        </div>
      </div>
      <div v-if="extra" class="form-item-extra">{{ extra }}</div>
      <div class="form-item-content">
        <slot />
        <div v-if="feedbackStatus" class="form-item-feedback">
          {{ feedbackText }}
        </div>
      </div>
    </div>
    <div v-if="arrow" class="form-item-arrow">
      <i class="crm-Icon_right"></i>
    </div>
  </div>
</template>

<script>
/* eslint-disable vue/require-default-prop, vue/require-prop-types */
export default {
  props: {
    name: {},
    asterisk: {},
    label: {},
    labelDesc: {},
    extra: {},
    message: {},
    feedbackText: {},
    feedbackStatus: {}, // 'error' | 'warning' | 'success' | 'pending'
    small: {},

    icon: {},
    arrow: {},
    marginTop: {},
    marginBottom: {},
    noPadding: {},
    noPaddingTop: {},
    borderRadiusTop: {},
    borderRadiusBottom: {},
    direction: {}, // 'vertical' | 'horizontal'
  },
}
</script>
<style lang="scss" scoped>
@import './style.scss';
</style>
